import { useState } from 'react';
import { Page, Card, Filters, Box, BlockStack, Pagination, InlineStack, Text } from '@shopify/polaris';
import { AuditLogPanel } from '../components/AuditLogPanel';

const PAGE_SIZE = 50;

export function AuditLog() {
  const [entityTable, setEntityTable] = useState('');
  const [entityId, setEntityId] = useState('');

  const applied = [
    entityTable && { key: 'table', label: `Table: ${entityTable}`, onRemove: () => setEntityTable('') },
    entityId && { key: 'id', label: `Entity: ${entityId}`, onRemove: () => setEntityId('') },
  ].filter(Boolean) as Array<{ key: string; label: string; onRemove: () => void }>;

  return (
    <Page title="Audit log" subtitle="Every create / update / delete / import, across all entities">
      <BlockStack gap="400">
        <Card>
          <Filters
            queryValue=""
            onQueryChange={() => {}}
            onQueryClear={() => {}}
            queryPlaceholder=""
            hideQueryField
            onClearAll={() => { setEntityTable(''); setEntityId(''); }}
            appliedFilters={applied}
            filters={[
              { key: 'table', label: 'Entity table', shortcut: true,
                filter: <input className="Polaris-TextField__Input" value={entityTable} onChange={(e) => setEntityTable(e.target.value)} placeholder="vehicles | wheel_products" /> },
              { key: 'id', label: 'Entity id',
                filter: <input type="number" className="Polaris-TextField__Input" value={entityId} onChange={(e) => setEntityId(e.target.value)} placeholder="123" /> },
            ]}
          />
        </Card>
        <AuditLogPanel
          entityTable={entityTable || undefined}
          entityId={entityId ? Number(entityId) : undefined}
          limit={PAGE_SIZE}
        />
      </BlockStack>
    </Page>
  );
}
